import Component from 'gia/Component';
import gsap from 'gsap'
import Marquee3k from '../vendor/marquee3k'

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element

    setTimeout(() => {
      Marquee3k.init({
        selector: 'marquee',
      })
    }, 100);

  }

  unmount()
  {

  }
}
